const FormatPrice = ({ price, user }) => {
  const USD_TO_INR = 90;

  let currency = "USD";
  let displayPrice = price;
  let locale = "en-US";

  if (user?.country === "India") {
    currency = "INR";
    displayPrice = price * USD_TO_INR;
    locale = "en-IN";

    // ✅ Round INR to nearest 10
    displayPrice = Math.round(displayPrice / 10) * 10;
  }

  return Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(displayPrice);
};

export default FormatPrice;